import { render } from "./SendPasswordResetEmail.vue?vue&type=template&id=2dc32bd8&lang=pug"
import script from "./SendPasswordResetEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./SendPasswordResetEmail.vue?vue&type=script&setup=true&lang=js"

import "./SendPasswordResetEmail.vue?vue&type=style&index=0&id=2dc32bd8&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QBtn,QField});
